news11.vue<template>
<div>
		<sub-header bizCd="10"/>
	 	<div class="sub_visual sub10">
            <div class="container">
                <div class="sub_txt">
                    <div class="tit">보도자료</div>
                    <div class="comment">언론에 소개된 에듀윌의 다양한 소식을 만나보세요.</div>
                </div>
            </div>
        </div>
        <div class="contents aos-all">
            <div class="container">
                <div class="sec">
                    <h3>보도자료</h3>
                    <div class="board">
                        <div class="board_header">
                            <h4>에듀윌, 폭스에듀와 MOU 체결… ‘미래 교육 판도 대변혁 시동’</h4>
                            <div class="board_meta">
<!--                                <ul>-->
<!--                                    <li>등록일 : 22.05.24</li>-->
<!--                                    <li>조회수 : 142</li>-->
<!--                                </ul>-->
                            </div>
                        </div>
                      <div class="board_body">
                            <div class="board_content">
                              <h2><span style="font-family:'맑은 고딕';"><strong>에듀윌,&nbsp;폭스에듀와 MOU&nbsp;체결… ‘미래 교육 판도 대변혁 시동’</strong></span>
                              </h2>
                              <p>&nbsp;</p>
                              <p><span style="font-family:'맑은 고딕';"><strong>-&nbsp;성인 교육·유아·초중고 교육 분야 협력으로 전 연령 맞춤 학습 서비스 제공</strong></span>
                              </p>
                              <p><span style="font-family:'맑은 고딕';"><strong>-&nbsp;차별화된 교육 콘텐츠 개발 및 미래 인재 양성 위한 공동 프로젝트 추진</strong></span>
                              </p>
                              <p>&nbsp;</p>
                              <figure class="image"><img src="//company.eduwill.net/contents/img/20250605133732.jpg"></figure>
                              <p><span style="font-family:'맑은 고딕';">▲사진 설명:&nbsp;에듀윌 양형남 대표(좌측)와 이종탁 폭스에듀 대표가 업무협약서에 서명 후 기념촬영을 하고 있다.</span>
                              </p>
                              <p>&nbsp;</p>
                              <p><br><span style="font-family:'맑은 고딕';">(2025.03.13) 종합교육기업 에듀윌(대표 양형남)이 지난 12일,&nbsp;서울 구로구 에듀윌 본사에서 에듀테크 기업 폭스에듀(대표 이종탁)와 미래 교육 콘텐츠 개발 및 협력을 위한 업무협약(MOU)을 체결했다고 13일 밝혔다.</span>
                              </p>
                              <p>&nbsp;</p>
                              <p><span style="font-family:'맑은 고딕';">이번 협약식에는 양형남 에듀윌 대표와 이종탁 폭스에듀 대표를 비롯한 양사 관계자들이 참석했다.&nbsp;또한,&nbsp;협약식과 함께 이종탁 대표가 에듀윌 자문위원으로 위촉되었으며,&nbsp;앞으로 에듀윌의 사업 전반에 대한 자문 역할을 수행할 예정이다.&nbsp;이어서 양사는 구체적인 협력 방안을 논의하며 협업 방향을 구체화했다.</span>
                              </p>
                              <p>&nbsp;</p>
                              <p><span style="font-family:'맑은 고딕';">폭스에듀는 하이브리드 러닝 플랫폼을 기반으로 학교 및 공교육기관과 협력하여 미래교육의 새로운 방향을 제시하는 에듀테크 기업이다.&nbsp;스스로 배움을 설계할 수 있는 메타인지 능력을 갖춘 미래인재 양성을 목표로 다양한 교육 솔루션을 개발하고 있으며,&nbsp;주요 사업으로 미래교실 공간 기획 및 컨설팅,&nbsp;콘텐츠 및 교육플랫폼 개발 등이 있다.</span>
                              </p>
                              <p>&nbsp;</p>
                              <p><span style="font-family:'맑은 고딕';">양사는 이번 협약을 통해 유아부터 성인까지 전 연령층을 위한 평생 교육 콘텐츠를 공동 개발하고,&nbsp;공공기관 및 교육기관에 차별화된 교육 서비스를 제공할 계획이다.&nbsp;이를 통해 미래 인재 양성에 기여하는 것을 목표로 한다.</span>
                              </p>
                              <p>&nbsp;</p>
                              <p><span style="font-family:'맑은 고딕';">협약 체결 즉시 양사는 협력 사업을 본격적으로 추진할 예정이다.&nbsp;특히,&nbsp;성인 교육 시장을 선도하는 에듀윌과 유아 및 초·중·고 교육 분야에서 강점을 지닌 폭스에듀의 협력으로 다양한 시너지가 창출될 것으로 보인다.</span>
                              </p>
                              <p>&nbsp;</p>
                              <p><span style="font-family:'맑은 고딕';">에듀윌 양형남 대표는 "이번 협약을 통해 에듀윌의 성인 교육 노하우와 폭스에듀의 기술력을 결합해 차별화된 교육 서비스를 제공할 것으로 기대된다"며, "앞으로도 더욱 효과적인 학습 환경을 조성하고,&nbsp;교육의 질을 높이는 데 힘쓰겠다"고 말했다.</span>
                              </p>
                              <p>&nbsp;</p>
                              <p><span style="font-family:'맑은 고딕';">폭스에듀 이종탁 대표는 "폭스에듀는 혁신적인 교육 서비스를 통해 유아부터 초·중·고 학습을 지원하고 있다"며, "이번 협력을 통해 보다 체계적인 교육 콘텐츠를 개발하고,&nbsp;미래 교육 시장의 혁신을 선도하는 데 기여하겠다"고 밝혔다.</span>
                              </p>
                              <p>&nbsp;</p>
                              <p><span style="font-family:'맑은 고딕';">한편,&nbsp;이번 협약은 에듀윌이 추진하는 ‘메가(Make Eduwill Great Again, MEGA)&nbsp;프로젝트’의 일환이다.&nbsp;에듀윌은 타 업종뿐만 아니라 동종 업계와도 적극적으로 협력하며,&nbsp;혁신적인 교육 방식을 모색하고 있다.&nbsp;이번 협약을 통해 보다 확장된 교육 생태계를 구축하고,&nbsp;국내 교육 시장에서 지속적인 성장을 이어갈 계획이다.</span>
                              </p>
                            </div>
                        </div>
                        <div class="board_nav">
                            <ul>

                                <!-- 이전 보도 기사가 있을 경우 -->

                                <li class="prev">
                                    <router-link to="/edu/newsRelease/promotionVideo/news20" data-value="315283">
                                        <strong>이전</strong>
                                        <span>에듀윌, HY교육과 '지방소멸 위기 극복' 위한 업무협약 체결</span>
                                    </router-link>
                                </li>

                                <!-- //이전 보도 기사가 있을 경우 -->

                              <!-- 다음 보도 기사가 있을 경우 -->
                              <li class="next">
                                <router-link to="/edu/newsRelease/promotionVideo/news18" data-value="315283">
                                  <strong>다음</strong>
                                  <span>에듀윌, 케어런츠·한국요양보호협회와 맞손… 프리미엄 요양보호사 양성 나선다!</span>
                                </router-link>
                              </li>
                              <!-- //다음 보도 기사가 있을 경우 -->

                            </ul>
                        </div>
                        <div class="board_footer">
                            <div class="button-area">
                                <router-link to="/edu/newsRelease/main" class="lg-btn">
                                목록으로
                                </router-link>                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import SubHeader from "@/layouts/SubHeader";

export default {
	name: "MainOnlineEdu",
	components: {SubHeader},
	data() {
		return {
			swiper : ""
		}
	},
	
	computed: {
	},
	
	methods: {
	},
	
	created() {
	},
	beforeMount() {
	},
	mounted() {
		AOS.init({ easing: 'ease-in-out-sine' })
		
		this.swiper = new Swiper("#vi-role.swiper-container", {
	        loop: true,
	        loopFillGroupWithBlank: true,
	        navigation: {
	          nextEl: ".swiper-button-next",
	          prevEl: ".swiper-button-prev"
	        }
	    });
		
		$(".pa_slider_scroll").simplyScroll({
	        customClass:'vert',
			speed: 5,
	        pauseOnHover : true
	    });
	},
	beforeDestroy() {
	},
	destroyed() {
	}
}
</script>
